import { React, useState } from 'react';
import { Button, Form, Modal, Input, Upload, message } from 'antd';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { InboxOutlined } from '@ant-design/icons';
import ChargingHttpHandler from '../../../../shared/chargingHttpHandler';
import secureStorage from '../../../../shared/secureStorage';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isBetween);

// 新增or修改客群Modal
const TargetModal = (props) => {
  const { modalVisible, setModalVisible, targetForm, isNew, fetchTargetInfo } =
    props;

  const httpHandler = new ChargingHttpHandler(false);
  const chargingAccessToken = secureStorage.getItem('chargingAccessToken');

  const addTarget = async () => {
    try {
      const values = await targetForm.validateFields();
      const api_info = isNew
        ? '/platform/add_target_customer'
        : `/platform/${values.id}`;

      const formdata = new FormData();

      const postData = {
        customer_name: values.customerName,
      };
      formdata.append('data', JSON.stringify(postData));
      if (values.customerUpload !== undefined) {
        formdata.append('file', values.customerUpload.file);
      }
      if (
        values.description !== null &&
        values.description !== '' &&
        values.description !== undefined
      ) {
        formdata.append('description', values.description);
      }

      const alert = isNew ? '確定新增客群？' : '確定修改客群？';
      const final = isNew ? '新增客群成功' : '修改客群成功';
      const confirmed = await window.antdConfirm(alert);
      if (!confirmed) {
        return;
      }

      await httpHandler
        .axios()
        .post(api_info, formdata, {
          headers: {
            'Content-Type': 'multipart/form-data; charset=UTF-8',
            Authorization: `Bearer ${chargingAccessToken}`,
          },
        })
        .then(() => {
          targetForm.resetFields();
          setModalVisible(false);
          fetchTargetInfo();
          message.success(final);
        });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Modal
      title={isNew ? '新增客群' : '修改客群'}
      open={modalVisible}
      onCancel={() => setModalVisible(false)}
      width={800}
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            setModalVisible(false);
            targetForm.resetFields();
          }}>
          取消
        </Button>,
        <Button
          type="primary"
          onClick={() => {
            addTarget();
          }}>
          確定
        </Button>,
      ]}>
      <ModalForm targetForm={targetForm} isNew={isNew} />
    </Modal>
  );
};

// 搜尋Modal專用的Form
const ModalForm = (props) => {
  const { Dragger } = Upload;
  const { targetForm, isNew } = props;
  const [fileData, setFileData] = useState(null);

  const handleDragger = ({ file, fileList, e }) => {
    setFileData(file);
  };

  return (
    <Form form={targetForm} layout="vertical">
      <Form.Item name="id" hidden>
        <Input />
      </Form.Item>
      <Form.Item
        label="客群名稱"
        name="customerName"
        rules={[{ required: true, message: '請輸入客群名稱' }]}>
        <Input placeholder="請輸入客群名稱" />
      </Form.Item>
      <Form.Item label="客群描述" name="customerDescription">
        <Input placeholder="請輸入客群描述" />
      </Form.Item>
      <Form.Item
        label="上傳客群"
        name="customerUpload"
        rules={isNew ? [{ required: true, message: '請上傳客群名單' }] : []}>
        <Dragger
          name="test_file"
          accept=".csv"
          maxCount={1}
          beforeUpload={() => false}
          onChange={handleDragger}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">點擊或拖曳檔案到此區域上傳</p>
          <p className="ant-upload-hint">
            僅支援單一檔案上傳，且檔案格式需為 .csv !
          </p>
        </Dragger>
      </Form.Item>
    </Form>
  );
};

// 驗證props
TargetModal.propTypes = {
  modalVisible: PropTypes.bool,
  setModalVisible: PropTypes.func,
  targetForm: PropTypes.object,
};

ModalForm.propTypes = {
  targetForm: PropTypes.object,
};

export default TargetModal;
